import httpHelper from "@/helpers/httpHelper";

const serverGameService = {
    async getAllByGame(idGame) {
        return await httpHelper.get("/WebApi/GameServer/GetAllByGame", {idGame});
    },
};

export default serverGameService;